import { SxProps } from '@mui/material';

export const custodianDetailsContainer: SxProps = {
  maxWidth: '80vw',
};

